export class NoMoreAvailableVideosError extends Error {
	constructor() {
		super("Couldn't perform operation because all available video players are currently busy");
		Object.setPrototypeOf(this, NoMoreAvailableVideosError.prototype);
	}
}
